module.exports = __webpack_public_path__ + "img/login-top2.422d900a.png";